import { connect } from 'react-redux'
import { List, Map } from 'immutable'
import { reduxForm } from 'redux-form/immutable'
import { createStructuredSelector } from 'reselect'
import { push } from 'connected-react-router'

import { TIME_PREFERENCES_FORM } from 'app/constants/profile'
import { saveProfile } from 'store/entities/identity/actions'
import { isShowHasIrregularWorkWeekBlock, getIdentityWorkWeek } from 'store/entities/identity/selectors'
import HasIrregularWorkWeek from './HasIrregularWorkWeek'

const mapStateToProps = createStructuredSelector({
  isShowHasIrregularWorkWeekBlock,
  userWorkWeek: getIdentityWorkWeek,
})

const mergeProps = ({ userWorkWeek, ...stateProps }, { dispatch }, ownProps) => ({
    ...stateProps,
    ...ownProps,
    onSubmit: () => {
      dispatch(saveProfile(Map({ workWeek: List(userWorkWeek.toJS()) })))
    },
    onSubmitAndGoToNotifications: () => {
      dispatch(saveProfile(Map({ workWeek: List(userWorkWeek.toJS()) })))
      dispatch(push('/profile/notifications'))
    }
})

export default connect(
  mapStateToProps,
  null,
  mergeProps
)(
  reduxForm({
    form: TIME_PREFERENCES_FORM,
    enableReinitialize: true,
    destroyOnUnmount: false,
  })(HasIrregularWorkWeek)
)
